import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import css from "./index.module.scss";

export default forwardRef(({
  children,
  className = "",
  onShow = () => {},
  onHide = () => {},
}, ref) => {
  const [isOpen, setIsOpen] = useState(false);

  let finalClassName = `${css.modal} ${className}`;
  if (isOpen){
    finalClassName += ` ${css.open}`;
  }

  useImperativeHandle(ref, () => ({
    show() {
      setIsOpen(true);
    },
    hide() {
      setIsOpen(false);
    },
  }));

  return (
    <div className={finalClassName} ref={ref}>
      <div className={css.alert}>
        {children}
      </div>
    </div>
  );
});
